import {addAirDatapicker} from './dates.js';


export function draw_drivers_table(data){
	$('.lead_update_popup #drivers_table tbody').empty();
	let qty_drivers = 0;

	if(Array.isArray(data) && data.length > 0){
		data.forEach(driver => {
			qty_drivers++;

			// If excluded=1, add a class to the row
			const rowClass = driver.excluded == 1 ? 'excluded-driver' : '';

			$('.lead_update_popup #drivers_table tbody').append(`
                <tr data-item_id="${driver.id}" data-type="drivers" class="${rowClass}">
                    <td class="edit" data-id="${driver.id}"></td>
                    
                    <td class="editable" data-name="first_name">${driver.first_name}</td>
                    <td class="editable" data-name="last_name">${driver.last_name}</td>
                    
                    <td class="editable editable_date" data-name="dob">
                        <div class="date_wrapper input-auto-size-wrapper">
                            <span class="size-span">
                                ${driver.dob !== '0/0/0000' && driver.dob != null ? driver.dob : ''}
                            </span>
                            <input readonly type="text" class="date" value="${driver.dob !== '0/0/0000' && driver.dob != null ? driver.dob : ''}">
                        </div>
                    </td>
                    
                    <td class="editable" data-name="license_number">${driver.license_number}</td>
                    <td class="editable" data-name="license_state_code">${driver.license_state_code}</td>
                    
                    <td class="editable editable_date" data-name="doh">
                        <div class="date_wrapper input-auto-size-wrapper">
                            <span class="size-span">
                                ${driver.doh !== '0/0/0000' && driver.doh != null ? driver.doh : ''}
                            </span>
                            <input readonly type="text" class="date" value="${driver.doh !== '0/0/0000' && driver.doh != null ? driver.doh : ''}">
                        </div>
                    </td>
                    
                    <td class="editable" data-name="yoe">${driver.yoe}</td>

                    <td class="excluded_cell">
                        <input type="checkbox"
                               class="excluded_checkbox"
                               data-id="${driver.id}"
                               ${driver.excluded == 1 ? 'checked' : ''}
                               disabled>
                    </td>
                    
                    <td class="delete"></td>
                </tr>
            `);
		});
	}

	$('.lead_update_popup #drivers_table tfoot').empty().append(`
        <tr>
            <td colspan="10">
                <button data-type="drivers" data-id="" class="abibus file_btn btn-success off save_item save_driver">
                    <span class="abib">Save Changes</span>
                </button>
                <button data-type="drivers" data-id="" class="abibus btn-cancel off cancel_edit">
                    <span class="abib">Cancel</span>
                </button>
                <button data-type="drivers" class="abibus file_btn add_new_item add_new_driver">
                    <span class="abib">Add Driver</span>
                </button>
            </td>
        </tr>
    `);

	$('.qty_drivers').html('[' + qty_drivers + ']');
}


export function draw_vehicles_table(data){
	let qty_vehicles = 0;
	$('.lead_update_popup #vehicles_table tbody').empty();
	if (Array.isArray(data) && (data).length > 0) {
		data.forEach(vehicle => {
			++qty_vehicles;

			$('.lead_update_popup #vehicles_table tbody').append(
				`<tr data-item_id="${vehicle.id}"   data-type="vehicles">
									<td class="edit" data-id="${vehicle.id}"></td>
									<td class="editable" data-name="vin">${vehicle.vin}</td>
									<td class="select" data-table="vehicle_types"  data-name="vehicle_type_id" data-id="${vehicle.vehicle_type_id}">${vehicle.vehicle_type_title}</td>
									<td class="editable" data-name="make">${vehicle.make}</td>
									<td class="editable" data-name="model">${vehicle.model}</td>
									<td class="editable" data-name="year">${vehicle.year}</td>
									<td class="delete"></td>
								</tr>`
			);
		});
	}

	//add new
	$('.lead_update_popup #vehicles_table tfoot').empty();
	$('.lead_update_popup #vehicles_table tfoot').append(
		`<tr>
				<td colspan="7">
				<button  data-type="vehicles" data-id="" class="  abibus file_btn btn-success off save_item save_vehicle"><span class="abib">Save Changes</span></button>
				<button  data-type="vehicles" data-id=""   class="  abibus btn-cancel off cancel_edit  "><span class="abib">Cancel</span></button>
				<button data-type="vehicles" class="  abibus file_btn add_new_item add_new_vehicle"><span class="abib">Add Vehicle</span></button>
				</td>
			</tr>`
	);

	$('.qty_vehicles').html('[' + qty_vehicles + ']');

}

export function draw_loss_run_table(data){
	let qty_loss_runs = 0;
	$('.lead_update_popup #loss_runs_table tbody').empty();
	if (Array.isArray(data) && (data).length > 0) {
		data.forEach(loss_run => {
			++qty_loss_runs;

			let file_link_html = '<a class="nosource">!</a>';
			if (loss_run.directory_path != null && loss_run.file_email_id != null && loss_run.source_filename != null) {
				file_link_html = `<a class="source" href="${loss_run.directory_path}/${loss_run.file_email_id}/${loss_run.source_filename}"></a>`;
			}
			let notes_html = '';
			if (loss_run.notes != null && String(loss_run.notes).trim() !== '') {
				notes_html = `<a class="notes" title="${loss_run.notes}"></a>`;
			}
			$('.lead_update_popup #loss_runs_table tbody').append(
				`<tr data-item_id="${loss_run.id}" data-type="loss_runs" class="${loss_run.status} ${+loss_run.invalid ? 'Invalid' : 'Valid'}" >
								<td><input data-type="loss_runs" data-id="${loss_run.id}" type="checkbox" class="valid_checkbox" ${+loss_run.invalid ? '' : 'checked'}  data-id="${loss_run.id}"></td>
								<td class="edit" data-id="${loss_run.id}"></td>
								<td class="editable editable_date" data-name="policy_start_date"><div class="date_wrapper input-auto-size-wrapper"><span class="size-span">${loss_run.policy_start_date !== '0/0/0000' && loss_run.policy_start_date != null ? loss_run.policy_start_date : ''}</span><input readonly type="text" class="date" value="${loss_run.policy_start_date !== '0/0/0000' && loss_run.policy_start_date != null ? loss_run.policy_start_date : ''}"></div></td>
								<td class="editable editable_date" data-name="policy_end_date"><div class="date_wrapper input-auto-size-wrapper"><span class="size-span">${loss_run.policy_end_date !== '0/0/0000' && loss_run.policy_end_date != null ? loss_run.policy_end_date : ''}</span><input readonly type="text" class="date" value="${loss_run.policy_end_date !== '0/0/0000' && loss_run.policy_end_date != null ? loss_run.policy_end_date : ''}"></td>
								<td class="editable" data-name="insurance_company">${loss_run.insurance_company}</td>
								<td class="editable no-wrap" data-name="policy_number">${loss_run.policy_number}</td>
								
								<td class="editable no-wrap" data-name="qty_of_vehicles">${loss_run.qty_of_vehicles}</td>
								 
								<td class="editable" data-name="loss_dollar">${loss_run.loss_dollar}</td>
								<td class="editable" data-name="qty_of_claims">${loss_run.qty_of_claims}</td>
								<td class="editable editable_date" data-name="run_date"><div class="date_wrapper input-auto-size-wrapper"><span class="size-span">${loss_run.run_date !== '0/0/0000' && loss_run.run_date != null ? loss_run.run_date : ''}</span><input readonly type="text" class="date" value="${loss_run.run_date !== '0/0/0000' && loss_run.run_date != null ? loss_run.run_date : ''}"></td>
 								<td>${notes_html}</td>
 								<td>${file_link_html}</td>
 								<td class="delete"></td>
							</tr>`,
			);
		});
	}
	;

	//add new
	$('.lead_update_popup #loss_runs_table tfoot').empty();
	$('.lead_update_popup #loss_runs_table tfoot').append(
		`<tr>
				<td colspan="13">
				<button  data-type="loss_runs" data-id="" class="  abibus file_btn btn-success off save_item save_loss_run"><span class="abib">Save Changes</span></button>
				<button  data-type="loss_runs" data-id=""   class="  abibus btn-cancel off cancel_edit  "><span class="abib">Cancel</span></button>
				<button data-type="loss_runs" class="  abibus file_btn add_new_item add_new_vehicle add_new_loss_run_btn "><span class="abib">Add Loss Run</span></button>
				</td>
			</tr>`
	);


	$('.qty_loss_runs').html('[' + qty_loss_runs + ']');

}


export function draw_terms_table(data){
	let qty_terms = 0;
	$('.lead_update_popup #terms_table tbody').empty();
	if (Array.isArray(data) && (data).length > 0) {
		data.forEach(term => {
			++qty_terms;
			$('.lead_update_popup #terms_table tbody').append(
				`<tr   >
								 
								<td   data-name="term_start_date_formatted">${term.term_start_date_formatted !=='0/0/0000' && term.term_start_date_formatted !==null ? term.term_start_date_formatted : ''}</td>
								<td   data-name="term_end_date_formatted">${term.term_end_date_formatted !=='0/0/0000' && term.term_end_date_formatted !==null ? term.term_end_date_formatted : ''}</td>
								<td   data-name="insurance_company">${term.insurance_company}</td>
								<td   data-name="loss_dollar">${term.loss_dollar}</td>
								<td   data-name="qty_of_claims">${term.qty_of_claims}</td>
								<td   data-name="run_date">${term.run_date_formatted !=='0/0/0000' && term.run_date_formatted !==null ? term.run_date_formatted : ''}</td>
								 <td   data-name="qty_of_vehicles">${term.qty_of_vehicles}</td>
								 
 								 
							</tr>`
			);
		});
	};

	//add new
	$('.lead_update_popup #terms_table tfoot').empty();


}


export function draw_claims_table(data) {
	$('.lead_update_popup #claims_table tbody').empty();
	if (Array.isArray(data) && (data).length > 0) {
		data.forEach(claim => {


			let notes_html = '';
			if (claim.notes != null && String(claim.notes).trim() !== '') {
				notes_html = `<a class="notes" title="${claim.notes}"></a>`;
			}
			let file_link_html = '<a class="nosource">!</a>';
			if (claim.directory_path != null && claim.file_email_id != null && claim.file_source != null) {
				file_link_html = `<a class="source" href="${claim.directory_path}/${claim.file_email_id}/${claim.file_source}"></a>`;
			}

			$('.lead_update_popup #claims_table tbody').append(
				`<tr data-item_id="${claim.id}" data-type="claims" class="${+claim.invalid ? 'Invalid' : 'Valid'}">
					<td data-name=""><input data-type="claims" data-id="${claim.id}" type="checkbox" class="valid_checkbox" ${+claim.invalid ? '' : 'checked'}  data-id="${claim.id}"></td>
					<td class="edit" data-id="${claim.id}"></td>
					<td class="editable editable_date" data-name="date_of_claim"><div class="date_wrapper input-auto-size-wrapper"><span class="size-span">${claim.date_of_claim_format !== '0/0/0000' && claim.date_of_claim_format != null ? claim.date_of_claim_format : ''}</span><input readonly type="text" class="date" value="${claim.date_of_claim_format !== '0/0/0000' && claim.date_of_claim_format != null ? claim.date_of_claim_format : ''}"></td>
					<td class="editable" data-name="claims_qty">${claim.claims_qty}</td>
					<td class="editable" data-name="total_loss_dollar">${claim.claim_loss_dollar_numeric != null ? claim.claim_loss_dollar_numeric : ''}</td>
					<td class="editable" data-name="claimant">${claim.claimant != null ? claim.claimant : ''}</td>
					<td >${notes_html}</td>
					<td >${file_link_html}</td>
					<td class="delete"></td>
				</tr>`,
			);
		});
	}

	//add new
	$('.lead_update_popup #claims_table tfoot').empty();
	$('.lead_update_popup #claims_table tfoot').append(
		`<tr>
				<td colspan="12">
				<button  data-type="claims" data-id="" class="  abibus file_btn btn-success off save_item"><span class="abib">Save Changes</span></button>
				<button  data-type="claims" data-id=""   class="  abibus btn-cancel off cancel_edit  "><span class="abib">Cancel</span></button>
				<button data-type="claims" class="  abibus file_btn add_new_item"><span class="abib">Add Claims</span></button>
				</td>
			</tr>`,
	);

	//add new
	$('.lead_update_popup #terms_table tfoot').empty();


}

function drawSelect(data){
	$('.select.editing').each(function () {
		let _this =  $(this);
		let current_id = _this.attr('data-id');
		let table = _this.attr('data-table');
		let name = _this.attr('data-name');
		$.ajax({
			type: "POST",
			dataType: "html",
			url: "/leads/get-select-data",
			data: {
				'current_id': current_id,
				'table': table,
				'name': name,
			},
			cache: false,
			success: function (data) {
				_this.html(data);
			}
		});

	});
}



function get_efficiency() {

	$.ajax({
		type: "POST",
		dataType: "json",
		url: "/leads/get-efficiency",
		data: {
			'lead_id': $('#lead_id').val(),
		},
		cache: false,
		success: function (data) {
			if(data.result.all_completed){
				$('.lead_update_popup #efficiency').val(data.ai_efficiency + '%');
			} else {
				$('.lead_update_popup #efficiency').val('');
			}
		}
	});
}

$(document).ready(function() {

	$(".tabs_wrap_content  .table").on("click", ".edit", function (e) {
		e.preventDefault();
		e.stopPropagation();

		$(this).parents('.table').find('.add_new_item').hide();
		$(this).parents('.table').find('.file_btn').removeClass('off');

		let item_id = $(this).attr('data-id');
		$(this).parents('.table').find('.file_btn').attr('data-id', item_id);

		$(this).parents('.table').find('.editable').attr('contenteditable', 'false').removeClass('editing');

		$(this).parent().find('.editable').not('.editable_date').attr('contenteditable', 'true').addClass('editing');
		$(this).parent().find('.editable.editable_date').addClass('editing');

		$(this).parent().find('.select').addClass('editing');

		addAirDatapicker($('.editable.editing .date'));

		drawSelect();

		// NEW: re-enable the excluded checkbox in this row
		$(this).parent().find('.excluded_checkbox').prop('disabled', false);
	});

	$(".tabs_wrap_content  .table").on("click", ".add_new_item", function (e) {
		e.preventDefault();
		e.stopPropagation();

		let type = $(this).attr('data-type');
		let lead_id = $('.lead_update_popup').attr('data-current-lead-id');

		// For the create-item AJAX call
		$.ajax({
			url: "/leads/create-item",
			type: "POST",
			dataType: "json",
			data: {
				'lead_id': lead_id,
				'type': type
			},
			cache: false,
			success: function (result) {
				if (result.code !== 'SUCCESS') {
					alert('Failed to create item.');
					return;
				}

				let table = $('.lead_update_popup #' + type + '_table');
				let item_id = result.item_id;

				// Depending on the type, build a different table row structure
				if (type === 'drivers') {
					// (1) DRIVERS row with "Excluded" checkbox
					// same columns as your normal drivers table
					// Default the new driver to not excluded => unchecked
					let tr = `
                <tr data-item_id="${item_id}" data-type="drivers">
                    <!-- Edit button cell -->
                    <td class="edit" data-id="${item_id}"></td>

                    <!-- first_name -->
                    <td class="editable editing" data-name="first_name" contenteditable="true"></td>

                    <!-- last_name -->
                    <td class="editable editing" data-name="last_name" contenteditable="true"></td>

                    <!-- dob (with date picker) -->
                    <td class="editable editable_date editing" data-name="dob" contenteditable="true">
                        <div class="date_wrapper input-auto-size-wrapper">
                            <span class="size-span"></span>
                            <input readonly type="text" class="date" value="">
                        </div>
                    </td>

                    <!-- license_number -->
                    <td class="editable editing" data-name="license_number" contenteditable="true"></td>
                    
                    <!-- license_state_code -->
                    <td class="editable editing" data-name="license_state_code" contenteditable="true"></td>
                    
                    <!-- doh (with date picker) -->
                    <td class="editable editable_date editing" data-name="doh" contenteditable="true">
                        <div class="date_wrapper input-auto-size-wrapper">
                            <span class="size-span"></span>
                            <input readonly type="text" class="date" value="">
                        </div>
                    </td>

                    <!-- yoe -->
                    <td class="editable editing" data-name="yoe" contenteditable="true"></td>

                    <!-- Excluded checkbox => default unchecked => excluded=0 -->
                    <td class="excluded_cell">
                        <input type="checkbox" class="excluded_checkbox editing" data-id="${item_id}">
                    </td>

                    <!-- delete cell -->
                    <td class="delete"></td>
                </tr>`;

					table.find('tbody').append(tr);

				} else if (type === 'vehicles') {
					// (2) VEHICLES row
					let fields = ['vin', 'make', 'model', 'year'];
					let tr = `<tr data-item_id="${item_id}" data-type="${type}">`;
					tr += `<td class="edit" data-id="${item_id}"></td>`;
					fields.forEach(function (field) {
						tr += `<td class="editable editing" data-name="${field}" contenteditable="true"></td>`;
					});
					tr += `<td class="delete"></td></tr>`;
					table.find('tbody').append(tr);

				} else if (type === 'loss_runs') {
					// (3) LOSS RUNS row
					let fields = [
						'policy_start_date','policy_end_date','insurance_company','policy_number',
						'loss_dollar','qty_of_claims','run_date'
					];
					let tr = `<tr data-item_id="${item_id}" data-type="${type}">`;
					// Example: for “valid_checkbox”, etc.
					tr += `<td><input data-type="loss_runs" data-id="${item_id}" type="checkbox" class="valid_checkbox" checked disabled></td>`;
					tr += `<td class="edit" data-id="${item_id}"></td>`;
					fields.forEach(function (field) {
						let isDateField = (['policy_start_date','policy_end_date','run_date'].indexOf(field) !== -1);
						let dateInput = isDateField
							? '<div class="date_wrapper input-auto-size-wrapper"><span class="size-span"></span><input readonly="" type="text" class="date" value="">'
							: '';
						let editableDateClass = isDateField ? 'editable_date' : '';
						tr += `<td class="editable ${editableDateClass} editing" data-name="${field}" contenteditable="true">${dateInput}</td>`;
					});
					tr += `<td></td>`;
					tr += `<td><a class="nosource">!</a></td>`;
					tr += `<td class="delete"></td></tr>`;
					table.find('tbody').append(tr);

				} else if (type === 'claims') {
					// (4) CLAIMS row
					let fields = ['date_of_claim','claims_qty','total_loss_dollar','claimant'];
					let tr = `<tr data-item_id="${item_id}" data-type="${type}">`;
					tr += `<td><input data-type="claims" data-id="${item_id}" type="checkbox" class="valid_checkbox" checked disabled></td>`;
					tr += `<td class="edit" data-id="${item_id}"></td>`;
					fields.forEach(function (field) {
						let isDateField = (field === 'date_of_claim');
						let dateInput = isDateField
							? '<div class="date_wrapper input-auto-size-wrapper"><span class="size-span"></span><input readonly="" type="text" class="date" value="">'
							: '';
						let editableDateClass = isDateField ? 'editable_date' : '';
						tr += `<td class="editable ${editableDateClass} editing" data-name="${field}" contenteditable="true">${dateInput}</td>`;
					});
					tr += `<td></td>`;
					tr += `<td><a class="nosource">!</a></td>`;
					tr += `<td class="delete"></td></tr>`;
					table.find('tbody').append(tr);

				}

				// Common to all item types after appending:
				table.find('.add_new_item').hide();
				table.find('.abibus').removeClass('off');
				table.find('.abibus').attr('data-id', item_id);

				// Activate datepickers for newly added fields
				addAirDatapicker($('.editable.editing .date'));

				// If you have an “efficiency” metric
				//get_efficiency();
			}
		});
	});


	//save table item
	$(".tabs_wrap_content  .table").on("click", ".save_item" , function (e) {
		e.preventDefault();
		e.stopPropagation();
		let type = $(this).attr('data-type');
		let item_id = $(this).attr('data-id');
		let table =  $(this).parents('.table');
		let row =  table.find('tr[data-item_id="' + item_id + '"]'); // Get the row being edited or saved


		let data = {
			'lead_id': $('.lead_update_popup').attr('data-current-lead-id'),
			'item_id': item_id,
			'type': type
		};

		// Gather data from each editable cell
		row.find('.editable').each(function () {
			let key = $(this).attr('data-name'); // Get the data-name attribute

			let value = $(this).text().trim(); // Get the cell content
			if($(this).find('.date').length > 0){
				value = $(this).find('.date').val(); // Get the date cell content
			}


			data[key] = value; // Add it to the data object
		});
		row.find('.select').each(function () {
			let key = $(this).attr('data-name'); // Get the data-name attribute

			let	value = $(this).find('select').val();

			data[key] = value; // Add it to the data object
		});

		// NEW: gather the excluded checkbox
		let excludedChecked = row.find('.excluded_checkbox').prop('checked');
		data['excluded'] = excludedChecked ? 1 : 0;

		$.ajax({
			url: "/leads/update-item",
			type: "POST",
			dataType: "json",
			data: data,
			cache: false,
			success: function (result) {
				if (result.code === 'SUCCESS') {
					// Update the row with the new item_id if it was a new item
					if (!item_id) {
						row.attr('data-item_id', result.item_id);
						row.find('.edit').attr('data-id', result.item_id);
					}

					// Optionally, show a success message or visually indicate the row has been saved

					row.find('.editable').attr('contenteditable', 'false').removeClass('editing');
					row.find('.excluded_checkbox').prop('disabled', true); // re-disable
					table.find('.save_item').addClass('off');
					table.find('.cancel_edit').addClass('off');
					table.find('.add_new_item').show();

					getLeadData($('.lead_update_popup').attr('data-current-lead-id'));
				} else {
					alert('Failed to save the item.');
				}
			},
			error: function () {
				alert('Error while saving the item.');
			}

		});
	});

	$('.tabs_wrap_content  .table').on('change', '.valid_checkbox', function (e) {
		e.stopPropagation();
		let type = $(this).attr('data-type');
		let item_id = $(this).attr('data-id');
		let table = $(this).parents('.table');
		let row = table.find('tr[data-item_id="' + item_id + '"]'); // Get the row being edited or saved


		let data = {
			'lead_id': $('.lead_update_popup').attr('data-current-lead-id'),
			'item_id': item_id,
			'type': type,
		};


		data['invalid'] = +!$(this).prop('checked');


		$.ajax({
			url: '/leads/update-item',
			type: 'POST',
			dataType: 'json',
			data: data,
			cache: false,
			success: function (result) {
				if (result.code === 'SUCCESS') {
					// Update the row with the new item_id if it was a new item
					if (!item_id) {
						row.addClass('data-item_id', result.item_id);
					}

					// Optionally, show a success message or visually indicate the row has been saved

					getLeadData($('.lead_update_popup').attr('data-current-lead-id'));
				} else {
					alert('Failed to save the item.');
				}
			},
			error: function () {
				alert('Error while saving the item.');
			},

		});
	});


	$('.tabs_wrap_content .table').on('click', '.cancel_edit', function (e) {

		$(this).parents('table').find('.editable').attr('contenteditable', 'false').removeClass('editing');
		$(this).parents('table').find('.save_item').addClass('off');
		$(this).parents('table').find('.cancel_edit').addClass('off');
		$(this).parents('table').find('.add_new_item').show();

	});
	$(".tabs_wrap_content .table").on("click", ".delete", function (e) {
		e.preventDefault();
		e.stopPropagation();

		let item_id = $(this).parent('tr').attr('data-item_id');
		let type = $(this).parent('tr').attr('data-type');

		if (confirm("Are you sure you want to delete this row?")) {
			$.ajax({
				url: "/leads/delete-item",
				type: "POST",
				dataType: "json",
				data: {
					'item_id' : item_id,
					'type' : type
				},
				cache: false,
				success: function (result) {
					if(result.code === 'SUCCESS'){
						$(`#${type}_table tr[data-item_id="${result.item_id}"]`).remove();

						getLeadData($('.lead_update_popup').attr('data-current-lead-id'));
					}
				}
			});
		}
	});

});
